var rsa = require('../util/rsa_dependencies/rsa');
var base64 = require('../util/rsa_dependencies/base64');
var RSA_MODULUS = 'BBB520D26CF57CE9EF22FAD847010FBB9D8F52DF0CCBC32BDE830BD9EA84165E17822FFBB07C2904824DF9E8DC537B472C3D222E37FF2D71181C670C327F497711BEF7192D61DF41304838FC03F9EACD2DDDAA02CAC5DE15B867B7076967657A6C3A2E56764B60D7D9DF92A35E649110051D6A6132F0812C6A5ECB2B89C7AF5D';
  var RSA_EXPONENT = '10001';

  var RSAKey = rsa.RSAKey;

  var RSA = function (modulus, exponent) {
    modulus = modulus || RSA_MODULUS;
    exponent = exponent || RSA_EXPONENT;

    this._encryption = new RSAKey();
    this._encryption.setPublic(modulus, exponent);
  };
  RSA.prototype.encode = function(content) {
    return this._encryption.encrypt(content)
  }
  RSA.prototype.encrypt = function (plain, type) {
    var result = this._encryption.encrypt(plain);
    if (typeof type === 'undefined' || type === 'hex') {
      return rsa.linebrk(result);
    }
    if (type === 'base64') {
      return rsa.linebrk(base64.hex2b64(result));
      // return base64.hex2b64(rsa.linebrk())
    }
    throw new Error('unexpected type');
  };


module.exports = RSA;
